export class MovimientoCashbackCreateDto {
    constructor() {
        this.idPaciente = null;
        this.idClinica = null;
        this.idEmpleadoSolicito = null;
        this.monto = null;
        this.aFavor = null;
    }
}